export default __webpack_public_path__ + "s4.png";